namespace Matrix.Rebalancer {
    export interface SummaryViewAllAccountForm {
        InstanceCode: Serenity.LookupEditor;
        AccountCode: FormatServiceLookupEditor;
        SortOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class SummaryViewAllAccountForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.SummaryViewAllAccount';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SummaryViewAllAccountForm.init)  {
                SummaryViewAllAccountForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = FormatServiceLookupEditor;
                var w2 = s.IntegerEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(SummaryViewAllAccountForm, [
                    'InstanceCode', w0,
                    'AccountCode', w1,
                    'SortOrder', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
